import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workRequestId'}/bidStatus`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workRequestId/bidStatus`;

export const URL = (workRequestId: number): RouteDefinition => `${baseRoute}/${workRequestId}/bidStatus`;
